import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '@fontsource/inter/index.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import * as Sentry from '@sentry/react';

awsExports.oauth.redirectSignIn = `${window.location.origin}/`;
awsExports.oauth.redirectSignOut = `${window.location.origin}/`;
Amplify.configure(awsExports);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENV || 'production',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: process.env.REACT_APP_IS_PROD === 'true' ? false : true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: process.env.REACT_APP_IS_PROD === 'true' ? true : false, // PII protection (especially prod)
      blockAllMedia: true // reduce payload size
    })
  ],
  // Session Replay
  replaysSessionSampleRate: process.env.REACT_APP_IS_PROD === 'true' ? 0.1 : 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: `${process.env.REACT_APP_VERSION_NUMBER}.${process.env.REACT_APP_BUILD_NUMBER}`
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
